// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import MainPage from './components/MainPage';
import DashBoard from './components/Dashboard';
import VerticalLinearStepper from './components/VerticalLinearStepper';
import About from './components/About';
import Contact from './components/Contact';
import Organogram from './components/Organogram';


function RoutesComponent() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="dashboard" element={<DashBoard/>} />
          <Route path="donation" element={<VerticalLinearStepper />} />
          <Route path="organogram" element={<Organogram />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Routes>
    </Router>
  );
}

export default RoutesComponent;
